import dayjs from 'dayjs/esm';
import utc from 'dayjs/esm/plugin/utc';
import timezone from 'dayjs/esm/plugin/timezone';
import customParseFormat from 'dayjs/esm/plugin/customParseFormat';
import localeData from 'dayjs/esm/plugin/localeData';
import advancedFormat from 'dayjs/esm/plugin/advancedFormat';
import weekday from 'dayjs/esm/plugin/weekday';
import isBetween from 'dayjs/esm/plugin/isBetween';
import isSameOrAfter from 'dayjs/esm/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/esm/plugin/isSameOrBefore';
import relativeTime from 'dayjs/esm/plugin/relativeTime';
import localizedFormat from 'dayjs/esm/plugin/localizedFormat';
import duration from 'dayjs/esm/plugin/duration';
import quarterOfYear from 'dayjs/esm/plugin/quarterOfYear';
import 'dayjs/esm/locale/ko';

// Day.js 플러그인 확장
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);
dayjs.extend(localeData);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(isBetween);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(relativeTime);
dayjs.extend(localizedFormat);
dayjs.extend(duration);
dayjs.extend(quarterOfYear);

// 기본 로케일 설정
dayjs.locale('ko');

export default dayjs;
